export const PERMS = {
    READ: 'report_transports.read',
    UPDATE: 'report_transports.update',
    DELETE: 'report_transports.delete',
    CREATE: 'report_transports.create',
    EXPORT: 'report_transports.export',
}
